import { Injectable } from '@angular/core';
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  ErrorMessage,
  ForgotLoginAttributes,
  ForgotLoginContent,
  ForgotLoginErrorMessages
} from '@com-delta-idp/mnx-login-ui';
import { OauthAEMConfig } from '@com-delta-idp/mnx-oauth';
import { nameConfig, regexList } from '../../../validator/regex-list';
import { LoginModalContent } from '../../models/aem';
import { ForgotLoginExtendedService } from './forgot-login-extended.service';
@Injectable({
  providedIn: 'root'
})
export class ForgotLoginHelperService extends ForgotLoginExtendedService {
  forgotLoginValidationForm!: UntypedFormGroup;
  createLoginForm(): UntypedFormGroup {
    this.forgotLoginValidationForm = new UntypedFormGroup({
      emailId: new UntypedFormControl(null, [
        Validators.required,
        this.email_pattern_check
      ]),
      firstName: new UntypedFormControl(null, [
        Validators.required,
        nameConfig.nameLengthConfig
          ? this.firstName_pattern_check_new
          : this.firstName_pattern_check
      ]),
      lastName: new UntypedFormControl(null, [
        Validators.required,
        nameConfig.nameLengthConfig
          ? this.lastName_pattern_check_new
          : this.lastName_pattern_check
      ])
    });
    return this.forgotLoginValidationForm;
  }

  getForgotLoginForm(): UntypedFormGroup {
    return this.forgotLoginValidationForm;
  }

  getForgotLoginAttributes(oauthConfig: OauthAEMConfig): ForgotLoginAttributes {
    return {
      errorCount: 0,
      submitAttempt: false,
      errorAlertBanner: false,
      firstNameControlTouched: false,
      lastNameControlTouched: false,
      isMfa: oauthConfig && oauthConfig.MFA_FLOW ? true : false,
      emailIdControlTouched: false,
      showFormAlert: false
    };
  }

  getForgotLoginScreenContent(
    loginAemResponse: LoginModalContent
  ): ForgotLoginContent {
    const { forgotLogin, pageHeader } = loginAemResponse;

    return {
      pageHeader: {
        ...pageHeader,
        headerTitle: forgotLogin.headerTitle,
        headerSubTitle: forgotLogin.headerSubTitle
      },
      errors: this.getForgotLoginErrorMessages(loginAemResponse),
      ...forgotLogin
    };
  }

  getForgotLoginFormControlName(control: string): string | void | undefined {
    for (const key of Object.keys(this.forgotLoginValidationForm.controls)) {
      if (key === control) return key;
    }
  }

  getForgotLoginErrorMessages(
    loginModalContent: LoginModalContent
  ): ForgotLoginErrorMessages {
    let emailIdErrorMessage = '',
      firstNameErrorMessage = '',
      lastNameErrorMessage = '',
      forgotLoginAlertWarning = '',
      // eslint-disable-next-line prefer-const
      formAlertErrorMessage = '';
    loginModalContent.errors.errorMessages.forEach((option: ErrorMessage) => {
      if (option['errorId'] === this.getForgotLoginFormControlName('emailId')) {
        emailIdErrorMessage = option['errorMessageDescription'];
      }
      if (
        option['errorId'] === this.getForgotLoginFormControlName('firstName')
      ) {
        firstNameErrorMessage = option['errorMessageDescription'];
      }
      if (
        option['errorId'] === this.getForgotLoginFormControlName('lastName')
      ) {
        lastNameErrorMessage = option['errorMessageDescription'];
      }
      forgotLoginAlertWarning = 'To continue, please correct the';
    });
    return {
      emailIdErrorMessage: emailIdErrorMessage,
      firstNameErrorMessage: firstNameErrorMessage,
      lastNameErrorMessage: lastNameErrorMessage,
      forgotLoginAlertWarning: forgotLoginAlertWarning,
      formAlertErrorMessage: formAlertErrorMessage
    };
  }

  email_pattern_check(control: AbstractControl): { [s: string]: boolean } {
    const value = control?.value?.value.trim();
    if (value) {
      if (value.match(regexList.userIdLength) && value.match(regexList.email)) {
        return <{ [s: string]: boolean }>(<unknown>null);
      }
    }
    return { INVALID_EMAIL: true };
  }

  getForgotLoginFormGroup(): UntypedFormGroup {
    return this.forgotLoginValidationForm;
  }
}
